<script setup lang="ts">
import { useRouter } from '@/composables/useRouter';
import { useStore } from '@/composables/useVuexHelpers';
import MainContentPanel from '@/components/display/general/MainContentPanel.vue';
import UserOrganizations from '@/components/user/UserOrganizations.vue';
import BreadCrumb from '@/components/general/BreadCrumb.vue';

const router = useRouter();
const store = useStore();

const title = 'MyOrganizations';

const getUserOrganizations = () => store?.dispatch('getUserOrganizations');

const goToCreateNewOrganization = () => {
  router.push('/organization/create');
};
</script>

<template>
  <div>
    <BreadCrumb
      :path="[
        {
          title: title,
          route: '/organizations',
        },
      ]"
    />
    <MainContentPanel
      :title="title"
      buttonIcon="Create-Organizations"
      buttonText="Add New"
      tooltip="Click here to create a new Organization."
      :buttonAction="goToCreateNewOrganization"
      padding="small"
    >
      <UserOrganizations :loadDataFunction="getUserOrganizations"></UserOrganizations>
    </MainContentPanel>
  </div>
</template>
